import { TextField, InputLabel, Stack } from '@mui/material';
import React from 'react';

interface SettingValueFieldProps {
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const SettingValueField: React.FC<SettingValueFieldProps> = ({ value, onChange }) => (
  <Stack
    direction={{ xs: 'column', sm: 'row' }}
    spacing={3}
    alignItems={{ xs: 'stretch', sm: 'center' }}>
    <InputLabel
      sx={{
        minWidth: { xs: 0, sm: 130 },
        color: 'text.primary',
        fontWeight: 500,
        mb: { xs: 1, sm: 0 },
      }}>
      Value
    </InputLabel>
    <TextField
      required
      value={value || ''}
      onChange={onChange}
      size="small"
      sx={{ flex: 1 }}
      fullWidth
    />
  </Stack>
);

export default SettingValueField;
